export const QA_NAME_MATCH_REQUEST_INFO = 'matchRequestInfo'

export const MATCH_REQUEST_THROTTLE_HOURS = 24

export const MATCH_REQUEST_HIDDEN_STAGES = [
  'selected',
  'approved',
  'rejected',
  'withdrawn',
]

export const QA_NAME_MATCH_RULES_LINK = 'matchRulesLink'
